// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3soY0","title":"styles_title__QAtjY"};